import React from 'react';
import { Box, Tooltip } from '@mui/material';

type AddressProps = {
  address: string;
  first?: number; // number of leading chars to show
  last?: number;  // number of trailing chars to show
  title?: string; // optional tooltip override
};

export default function Address({ address, first = 5, last = 5, title }: AddressProps) {
  const [copied, setCopied] = React.useState(false);

  const truncated = React.useMemo(() => {
    if (!address) return '';
    if (address.length <= first + last) return address;
    return `${address.slice(0, first)}...${address.slice(-last)}`;
  }, [address, first, last]);

  const onCopy = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(address);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1400);
    } catch (_) {
      // no-op
    }
  };

  return (
    <Tooltip
      title={copied ? 'Copied!' : (title || address)}
      arrow
      placement="top"
      open={copied ? true : undefined}
    >
      <Box
        component="span"
        onClick={onCopy}
        sx={{
          cursor: 'pointer',
          userSelect: 'none',
          fontFamily:
            'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
          display: 'inline-flex',
          alignItems: 'center',
          '&:hover': { textDecoration: 'underline' },
        }}
      >
        {truncated}
      </Box>
    </Tooltip>
  );
}


